import { useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $generateNodesFromDOM } from '@lexical/html';
import { $getRoot, CLEAR_HISTORY_COMMAND } from 'lexical';
import { useTranslation } from '@packlink/translation-provider';

type HTMLLoaderPluginProps = {
    initialHTML?: string;
};

export function HTMLLoaderPlugin({ initialHTML }: HTMLLoaderPluginProps) {
    const [editor] = useLexicalComposerContext();
    const { i18n } = useTranslation();

    useEffect(() => {
        if (!initialHTML) return;

        editor.update(() => {
            const parser = new DOMParser();
            const dom = parser.parseFromString(initialHTML, 'text/html');
            const nodes = $generateNodesFromDOM(editor, dom);

            const root = $getRoot();
            root.clear();
            root.append(...nodes);
            editor.dispatchCommand(CLEAR_HISTORY_COMMAND, undefined);
        });
        // If the page is refreshed and the language is different from the initial language (eg: Spanish tenant and client with English language),
        // the editor needs to be updated to get the right language for the tags.
    }, [editor, initialHTML, i18n.language]);

    return null;
}
